import React from "react";
import "./MainContainer.scss";

interface MainContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const MainContainer: React.FC<MainContainerProps> = ({ children, ...rest }) => (
  <div className="main-content-container" {...rest}>
    {children}
  </div>
);

export default MainContainer;
